// frontend/src/hooks/handleBirthdateBlur.js

import MEMBER_VALIDATION_CONFIG from '../config/memberValidation'

/**
 * Controla la validación de fecha de nacimiento al perder el foco.
 * Si la edad está fuera del rango permitido, limpia el campo.
 *
 * @param {Object} e - Evento onBlur.
 * @param {Function} onChange - Función para actualizar el campo.
 */
export function handleBirthdateBlur(e, onChange) {
  const rawValue = e.target.value

  if (!rawValue) {
    onChange(e)
    return
  }

  const parts = rawValue.split("-")
  if (
    parts.length !== 3 ||
    parts[0].length !== 4 ||
    parts[1].length !== 2 ||
    parts[2].length !== 2
  ) {
    return
  }

  const birthDate = new Date(rawValue)
  if (isNaN(birthDate.getTime())) return

  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  const dayDiff = today.getDate() - birthDate.getDate()
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) age--

  const { min, absoluteMax } = MEMBER_VALIDATION_CONFIG.age

  if (age < min || age > absoluteMax) {
    onChange({ target: { name: 'birthdate', value: '' } })
    return
  }

  onChange(e)
}
